(() => {
  if (customElements.get('logo-slider')) {
    return;
  }

  class LogoSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        type: 'loop',
        perPage: 1,
        autoHeight: true,
        autoplay: false,
        rewind: true,
        rewindByDrag: true,
        waitForTransition: false,
        arrows: true,
        pagination: false,
        mediaQuery: 'min',
        breakpoints: {
          768: {
            destroy: true
          }
        }
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.js-slider')) return;

      this.slider = new Splide(
        this.querySelector('.js-slider'),
        this.options
      ).mount();
    }
  }

  customElements.define('logo-slider', LogoSlider);
})();
